import AxiosClient from "../../../services/axios.services";

class SessionNotificationServices {
  getSessionNotification = (params) =>
    AxiosClient.get("/api/app/Funcional_recordatorio_conexion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveSessionNotification = (data) =>
    AxiosClient.post("/api/app/Funcional_recordatorio_conexion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editSessionNotification = (id, data) =>
    AxiosClient.put(`/api/app/Funcional_recordatorio_conexion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteSessionNotification = (id) =>
    AxiosClient.delete(`/api/app/Funcional_recordatorio_conexion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new SessionNotificationServices();
